/** Only the two fields the placement reads, so callers are not forced to build a whole shift. */
interface ShiftPlacementSource {
  Team?: { name?: string };
  department_name?: string;
}

/**
 * Team and department, each skipped when it does not resolve — a deleted team
 * falls back to an empty name, and joining blindly leaves dangling separators.
 */
export const toShiftPlacement = (shift: ShiftPlacementSource | undefined): string =>
  [shift?.Team?.name, shift?.department_name].filter(Boolean).join(' · ');
